module.exports = __webpack_public_path__ + "static/Grupo 69-10ff79be2ee8791289420d0b6663a627.svg";